export default class SystemConst {
  static readonly SALON_TYPE = [
    { label: "すべてのサロンジャンル", value: "all" },
    { label: "ヘアサロン", value: "hair_genre" },
    { label: "ネイルサロン", value: "nail_genre" },
    { label: "まつげサロン", value: "eyelash_genre" },
    { label: "リラクサロン", value: "relax_genre" },
    { label: "パーソナルジム/ジム", value: "gym_genre" },
    { label: "エステサロン", value: "esthetic_genre" },
    { label: "脱毛サロン", value: "space_genre" },
    { label: "その他", value: "other_genre" },
  ];
  static readonly SALON_TYPE_ALL = "all";

  static readonly TICKET_TYPE = [
    { label: "すべてのサービス", value: "all" },
    { label: "単品サービス", value: "single_item_service" },
    { label: "回数券サービス", value: "ticket_service" },
    { label: "定額(サブスク)サービス", value: "flat_rate_service" },
  ];
  static readonly TICKET_TYPE_ALL = "all";
  static readonly TICKET_TYPE_ONEC = 1;
  static readonly TICKET_TYPE_MULTIPLE = 2;
  static readonly TICKET_TYPE_SUBSCRIPTION = 3;
  static readonly TICKET_TYPE_DB_COUPON = 1;
  static readonly TICKET_TYPE_DB_SUBSCRIPTION = 2;

  static readonly TICKET_STATUS_ALL = 0;
  static readonly TICKET_STATUS_UNUSE = 1;
  static readonly TICKET_STATUS_USED = 2;
  static readonly TICKET_STATUS_CANCEL = 3;
  static readonly TICKET_STATUS_CAN_USE = 4;
  static readonly TICKET_STATUS_CAN_NOT_USE = 5;

  static readonly CONSUMPTION_TAX = 1.1;

  static readonly STRIPE_KEY = "pk_test_PXvJq2psSEW7yDsWsyoA8AE200HPnjwmO2";

  static readonly SETTING_TYPE = [
    { label: "プロフィール編集", value: "SettingProfile" },
    { label: "メールアドレス変更", value: "SettingEmail" },
    { label: "パスワード変更", value: "SettingPassword" }
  ];

  static readonly TICKET_SERVICE_TYPE_ONEC = "single_item_service";
  static readonly TICKET_SERVICE_TYPE_MULTIPLE = "ticket_service";
  static readonly TICKET_SERVICE_TYPE_SUBSCRIPTION = "flat_rate_service";

  static readonly PURCHASED_TICKET_SECRET_SALE_LABEL = "シークレットサービス";

  static readonly PURCHASED_TICKET_STATUS_ALL = "all";
  static readonly PURCHASED_TICKET_STATUS_USED = "used";
  static readonly PURCHASED_TICKET_STATUS_UNUSE = "unuse";
  static readonly PURCHASED_TICKET_STATUS_CANCELED = "canceled";
  static readonly PURCHASED_TICKET_SECRET_SALE = "secret_sale";
  static readonly MAX_AVAILABLE_COUNT = 999;
  static readonly MAX_AVAILABLE_COUNT_OF_SALON = 0;

  static readonly TICKET_BUY_ORDER = "TicketBuyOrder";
  static readonly TICKET_BUY_CHECK = "TicketBuyCheck";
  static readonly TICKET_BUY_DONE = "TicketBuyDone";
}
